import { render } from "./Aboutme.vue?vue&type=template&id=5f2a3816"
import script from "./Aboutme.vue?vue&type=script&lang=js"
export * from "./Aboutme.vue?vue&type=script&lang=js"

import exportComponent from "/builds/springup/workstats-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__